/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
import { useMemo } from 'react';
import Text from '../../../assets/styles/Text';
import * as styles from '../styles';

export default function ServicesSection({
  services,
  selectedServices,
  onServiceChange,
  onServiceRemove,
}) {
  const hasValue = (serviceId) => {
    const value = selectedServices[serviceId];
    return value !== undefined && value !== null && value !== '';
  };

  // ✅ Organizar serviços em duas colunas
  const organizedServices = useMemo(() => {
    if (!Array.isArray(services) || services.length === 0) {
      return { leftColumn: [], rightColumn: [] };
    }

    const middle = Math.ceil(services.length / 2);

    return {
      leftColumn: services.slice(0, middle),
      rightColumn: services.slice(middle),
    };
  }, [services]);

  // ✅ Renderizar um serviço
  const renderService = (service) => (
    <styles.ServiceGroup key={service.id}>
      <Text.P>{service.name}</Text.P>
      <Text.Span>{service.description}</Text.Span>

      {selectedServices[service.id] && (
        <styles.Selected>
          <Text.Span>
            Selecionado:{' '}
            {selectedServices[service.id] === 'NAO'
              ? 'Não'
              : selectedServices[service.id] === 'SIM'
              ? 'Sim'
              : 'Sim, com taxa adicional'}
          </Text.Span>
        </styles.Selected>
      )}

      <styles.ServiceOptions>
        <styles.ServiceOption
          type="button"
          $checked={selectedServices[service.id] === 'NAO'}
          onClick={() => onServiceChange(service.id, 'NAO')}
        >
          <Text.Span>Não</Text.Span>
        </styles.ServiceOption>

        <styles.ServiceOption
          type="button"
          $checked={selectedServices[service.id] === 'SIM'}
          onClick={() => onServiceChange(service.id, 'SIM')}
        >
          <Text.Span>Sim</Text.Span>
        </styles.ServiceOption>

        <styles.ServiceOption
          type="button"
          $checked={selectedServices[service.id] === 'COM_TAXA_ADICIONAL'}
          onClick={() => onServiceChange(service.id, 'COM_TAXA_ADICIONAL')}
        >
          <Text.Span>Sim, com taxa adicional</Text.Span>
        </styles.ServiceOption>
      </styles.ServiceOptions>

      {hasValue(service.id) && (
        <styles.ButtonRemove
          type="button"
          onClick={() => onServiceRemove(service.id)}
        >
          <Text.Span>Limpar seleção</Text.Span>
        </styles.ButtonRemove>
      )}
    </styles.ServiceGroup>
  );

  return (
    <styles.FiltersContainer>
      <Text.H1>INFORMAÇÕES SOBRE VOCÊ</Text.H1>

      {/* ✅ Mesma estrutura de colunas dos filtros */}
      <styles.FiltersRow>
        <styles.FiltersColumn>
          {organizedServices.leftColumn.map((service) =>
            renderService(service)
          )}
        </styles.FiltersColumn>

        <styles.VerticalDivider />

        <styles.FiltersColumn>
          {organizedServices.rightColumn.map((service) =>
            renderService(service)
          )}
        </styles.FiltersColumn>
      </styles.FiltersRow>
    </styles.FiltersContainer>
  );
}
